import styled from "styled-components";
import { } from "../../../constants";

export const Agrupable = styled.span``;

export const ButtonModal = styled.button``;
